export const checkToken = () => Promise.resolve(true);
